import React, {Dispatch, SetStateAction, useEffect, useMemo, useState} from 'react'
import {useRouteManagement} from '../RouteManagementProvider'
import {KTIcon} from '../../../../_metronic/helpers'
import {useMutation, useQueryClient} from 'react-query'
import axios, {AxiosResponse} from 'axios'
import {BASE_URL} from '../../config'
import toast from 'react-hot-toast'
import {useListView} from '../../../utils/contextProvider/ListViewProvider'
import useSenderIdsOptions from '../../../hooks/useSenderIdsOptions'
import {FixedSizeList as List, ListChildComponentProps} from 'react-window'
import {useFormik} from 'formik'
import {
  initAddSenderFormValues,
  IRouteSenderDetails,
  IRouteSenderRoles,
  statusOptions,
} from '../_model'
import ReactSelectBox from '../../../utils/components/ReactSelectBox'
import {Button} from 'react-bootstrap'
import {ISelectOption} from '../../../utils/core/_model'
import ListPlaceholder from '../../../utils/components/Skeleton/ListPlaceholder'
import {handleApiError, handleAxiosError} from '../../../utils/helperFunction/_helper'

const ADD_NEW_SENDERS_URL = `${BASE_URL}/api/protect/addRouteRolesSender`

type SendValues = {
  id: string
  sourceId: number
  sourceSenderId: number[]
  destinationId: number
  destinatioSenderId: number[]
  status: string
}

type Props = {
  rolesid: string | undefined
  routeSenderRolesDetails: IRouteSenderRoles | null
  source_senders: ISelectOption[] | undefined
  destination_senders: ISelectOption[] | undefined
}

interface ListChildProps extends ListChildComponentProps {
  data: {
    items: ISelectOption[]
    selectionType: 'source' | 'destination'
    onSelect: (type: 'source' | 'destination', item: ISelectOption) => void
  }
}

const Row = ({index, style, data}: ListChildProps) => {
  const item = data.items[index]
  const selectionType = data.selectionType

  //   const onHandleSelect = () => {
  //     const formatedItem = {
  //       id: item.id,
  //       value: item.value,
  //     }

  //     if (selectionType === 'source') {
  //     }

  //     if (selectionType === 'destination') {
  //     }
  //   }

  const onHandleSelect = () => {
    data.onSelect(selectionType, item)
  }

  return (
    <div
      style={style}
      className='cursor-pointer bg-hover-danger rounded px-4 py-3'
      onClick={onHandleSelect}
    >
      {item.value}
    </div>
  )
}

const AddSender = ({
  routeSenderRolesDetails,
  rolesid,
  source_senders,
  destination_senders,
}: Props) => {
  const queryClient = useQueryClient()
  // const {senderIdsOptions, isLoading} = useSenderIdsOptions()

  const [isLoading, setIsLoading] = useState(true)
  const [sourceSenders, setSourceSenders] = useState<ISelectOption[]>([])
  const [destinationSenders, setDestinationSenders] = useState<ISelectOption[]>([])
  const [searchSourceSender, setSearchSourceSender] = useState('')
  const [searchDestinationSender, setSearchDestinationSender] = useState('')

  const {mutateAsync: addsender} = useMutation({
    mutationFn: async (data: {sendvalues: SendValues}) => {
      toast.loading('Processing..')
      const response = await axios.post(ADD_NEW_SENDERS_URL, data.sendvalues)
      console.log(response)
    },
    onSuccess: () => {
      toast.dismiss()
      toast.success('Successfully addedd')
      queryClient.invalidateQueries(['createRouteSenderRoles'])
      resetForm()
    },
    onError: (error: Error) => {
      toast.dismiss()
      console.log(error)
      // const message = handleApiError(error)
      const message = handleAxiosError(error)
      toast.error(message)
      console.log(message)
    },
  })

  const formik = useFormik({
    initialValues: initAddSenderFormValues,
    onSubmit: async (values) => {
      try {
        console.log(values)

        const sourceSenderid = values.sourceSender.map((sender) => sender.id)
        const destinationSenderid = values.destinationSender.map((sender) => sender.id)

        if (
          !rolesid ||
          !routeSenderRolesDetails?.sourceId ||
          !routeSenderRolesDetails?.destinationId
        ) {
          // handle error (e.g. show toast or return early)
          return
        }

        const sendvalues = {
          id: rolesid,
          sourceId: routeSenderRolesDetails?.sourceId,
          sourceSenderId: sourceSenderid,
          destinationId: routeSenderRolesDetails?.destinationId,
          destinatioSenderId: destinationSenderid,
          status: values.status === 'Active' ? '1' : '0',
        }

        await addsender({sendvalues})
      } catch (error) {
        console.log(error)
      }
    },
  })

  const resetForm = () => {
    formik.resetForm()
  }

  const handleSelect = (type: 'source' | 'destination', item: ISelectOption) => {
    if (type === 'source') {
      formik.setFieldValue('sourceSender', [...formik.values.sourceSender, item])
    } else {
      formik.setFieldValue('destinationSender', [...formik.values.destinationSender, item])
    }
  }

  const filteredSourceSender = useMemo(() => {
    if (sourceSenders.length > 0) {
      return sourceSenders.filter((item) =>
        item.value.toLowerCase().includes(searchSourceSender.toLowerCase())
      )
    } else {
      return []
    }
  }, [searchSourceSender, sourceSenders])

  const filteredDestinationSender = useMemo(() => {
    if (destinationSenders.length > 0) {
      return destinationSenders.filter((item) =>
        item.value.toLowerCase().includes(searchDestinationSender.toLowerCase())
      )
    } else {
      return []
    }
  }, [searchDestinationSender, destinationSenders])

  // console.log(formik.values.sourceSender)
  // console.log(formik.values.destinationSender)

  // useEffect(() => {
  //   if (routeSenderRolesDetails && senderIdsOptions.length > 0) {
  //     const filterSourceSender = senderIdsOptions.filter(
  //       (sender) => sender.routeconfid === routeSenderRolesDetails.sourceId
  //     )
  //     const filterDestinationSender = senderIdsOptions.filter(
  //       (sender) => sender.routeconfid === routeSenderRolesDetails.destinationId
  //     )
  //     console.log('source', filterSourceSender)
  //     console.log('destination', filterDestinationSender)

  //     setSourceSenders(filterSourceSender)
  //     setDestinationSenders(filterDestinationSender)

  //     // console.log(routeSenderRoles)
  //   }
  // }, [senderIdsOptions, routeSenderRolesDetails])

  useEffect(() => {
    if (source_senders && destination_senders) {
      setSourceSenders(source_senders)
      setDestinationSenders(destination_senders)
      setIsLoading(false)
    }
  }, [source_senders, destination_senders])

  return (
    <div className='modal fade' tabIndex={-1} id='kt_modal_1'>
      {/* begin::Modal dialog */}
      <div className='modal-dialog modal-dialog-centered modal-xl p-12'>
        {/* begin::Modal content */}
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title fs-2'>Add Sender</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTIcon iconName='cross' className='fs-1' />
            </div>
          </div>
          {/* begin::Modal body */}
          <div className='modal-body scroll-y my-5 mx-10'>
            <form onSubmit={formik.handleSubmit}>
              <div className='d-flex gap-8'>
                <div>
                  <h3>Source Sender</h3>

                  {isLoading ? (
                    <ListPlaceholder />
                  ) : (
                    <div className='bg-light w-100 mt-5 rounded'>
                      <input
                        placeholder='Search'
                        type='text'
                        value={searchSourceSender}
                        onChange={(e) => setSearchSourceSender(e.target.value)}
                        className='form-control custom-input'
                      />
                      <div className='w-100 px-4 py-4'>
                        <List
                          height={400}
                          itemCount={filteredSourceSender.length}
                          itemSize={40}
                          width={'100%'}
                          itemData={{
                            items: filteredSourceSender,
                            selectionType: 'source',
                            onSelect: handleSelect,
                          }}
                        >
                          {Row}
                        </List>
                      </div>
                    </div>
                  )}
                </div>

                <div>
                  <h3>Destination Sender</h3>

                  {isLoading ? (
                    <ListPlaceholder />
                  ) : (
                    <div className='bg-light w-100 mt-5 rounded'>
                      <input
                        placeholder='Search'
                        type='text'
                        value={searchDestinationSender}
                        onChange={(e) => setSearchDestinationSender(e.target.value)}
                        className='form-control custom-input'
                      />
                      <div className='w-100 px-4 py-4'>
                        <List
                          height={400}
                          itemCount={filteredDestinationSender.length}
                          itemSize={40}
                          width={'100%'}
                          itemData={{
                            items: filteredDestinationSender,
                            selectionType: 'destination',
                            onSelect: handleSelect,
                          }}
                        >
                          {Row}
                        </List>
                      </div>
                    </div>
                  )}
                </div>

                <div>
                  {formik.values.sourceSender.length > 0 ? (
                    <>
                      <div className='text-gray-800 fs-4 d-flex align-items-center gap-2'>
                        Source
                        <KTIcon iconName='arrow-right' className='fs-2hx' />
                        Destination
                      </div>
                      <div className='text-gray-700 fs-4 d-flex flex-column gap-2'>
                        {formik.values.sourceSender.length > 0 &&
                          formik.values.sourceSender.map((sender, index: number) => {
                            return (
                              <div key={index} className='d-flex align-items-center gap-2'>
                                {sender.value}
                                <KTIcon iconName='arrow-right' className='fs-2hx' />
                                {formik.values.destinationSender.length > 0 &&
                                  formik.values.destinationSender[index]?.value}
                              </div>
                            )
                          })}
                      </div>

                      {/* <hr /> */}

                      {/* <div className='text-gray-700 fs-4 d-flex flex-column gap-2'>
                        {formik.values.sourceSender.length > 0 ? (
                          Array.from(
                            {
                              length: Math.min(
                                formik.values.sourceSender.length,
                                formik.values.destinationSender.length
                              ),
                            },
                            (_, index) => (
                              <div key={index} className='d-flex align-items-center gap-2'>
                                <span>{formik.values.sourceSender[index]?.value || 'N/A'}</span>
                                <KTIcon iconName='arrow-right' className='fs-2hx' />
                                <span>
                                  {formik.values.destinationSender[index]?.value || 'N/A'}
                                </span>
                              </div>
                            )
                          )
                        ) : (
                          <span>No source or destination selected</span>
                        )}
                      </div> */}
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>

              <div className='fv-row mt-7 mb-7'>
                <label className='fw-semibold fs-6 mb-2'>Status</label>

                <ReactSelectBox
                  formik={formik}
                  fieldValue='status'
                  placeholder='Select value'
                  options={statusOptions}
                />
              </div>

              <div className='text-end'>
                <Button variant='light' data-bs-dismiss='modal' aria-label='Close' className='me-4'>
                  Cancel
                </Button>
                <Button type='submit' variant='primary' data-bs-dismiss='modal' aria-label='Close'>
                  Add
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddSender
